import useSWR from 'swr';
import { useMemo } from 'react';
import {AXIOS} from "../../../services/api";

const ITEMS_PER_PAGE = 12;

export function useApplicationsData(accountId, currentPage) {
	const swrKey = accountId
		? `accounts/${accountId}/applications?page=${currentPage}&size=${ITEMS_PER_PAGE}`
		: null;

	const { data, error, isLoading, mutate } = useSWR(swrKey, AXIOS.get);

	const applications = useMemo(() => data?.data?.data || [], [data]);
	const totalPages = useMemo(() => data?.data?.meta?.last_page || 0, [data]);
	const hasApplications = useMemo(() => applications.length > 0, [applications]);
	const isFirstLoad = isLoading && !data && !error;

	return {
		applications,
		totalPages,
		hasApplications,
		isLoading: isFirstLoad,
		isValidating: isLoading,
		error,
		mutate,
		itemsPerPage: ITEMS_PER_PAGE,
	};
}
